// custom megamenu toggle rule
// active only for EMPTY LINKS

$('.-custom-menu-item').on('click', function(evt) {
  evt.preventDefault();
  var link_address = $('.-open-submenu', this).attr('href');
  
  
  
  if( link_address == '#' ){
    evt.preventDefault();
    $(this).children().find('i').toggleClass('ad-plus-l ad-minus-l');
    $(this).children('ul').slideToggle();
    
    
    $('a.site-nav').on('click', function(e) {
      e.preventDefault();
    	window.location = $(this).attr('href');
    });
  } 
  
  else { window.location = link_address; }
});

$('.-open-submenu .ad').on('click', function(e){
  	e.preventDefault(); 
});

$('.-custom-menu-item .ad').on('click', function(evt) {
  var link_address = $(this).parent().filter("[href]").attr('href');  
  if( link_address == '#' ){ $(this).parent().find('ul').slideToggle(); }
  else{}                            
});





$(document).on('click', '.-must-select', function(){
  $(this).closest('.productForm').addClass('-selected');
});



function showMarimeAlert(){
  	$('.-marime-alert').css({'display': 'block'});
  
  setTimeout(function(){
    $('.-marime-alert').css({'display': 'none'});
  }, 1500)
  
}


// $('.product-form__cart-submit').on('click', function(e){
  

//	$(this).parent('form').hasClass('-selected')
  
//   if( $(this).parent('form').find('.-must-select').hasClass('-selected') ){
   	
//   }
//   else {
    
//     e.preventDefault();
  
//   }
  
  
// });